angular.module('unica_user.user_services')

.factory('UserEditService', function ($http, $rootScope, getBaseApiURL) {

	var userEditService = {};

	userEditService.update = function (userData, step) {

		var userData = angular.copy(userData);

		userData.dob = moment( userData.dob ).format('YYYY-MM-DD');

		if ( userData.props.doc_emission_date ) {
			userData.props.doc_emission_date = moment( userData.props.doc_emission_date ).format('YYYY-MM-DD');
		}

		if ( userData.props.doc_expiration_date ) {
			userData.props.doc_expiration_date = moment( userData.props.doc_expiration_date ).format('YYYY-MM-DD');
		}

		userData.step = step;

		return $http({
			method: 'post',
			url: getBaseApiURL + '/user/update/' + userData.id,
			data: userData
		}).then(function(result) {

			if ( result ) {
				if ( result.data.error ) {
					$rootScope.showErrorMsg( result.data.error, '');
				} else {
					return result.data.user;
				}
			}

		});

	};

	return userEditService;
});